/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ArchiveUserBodyDTO } from '../model/models';
import { ArchiveUserDTO } from '../model/models';
import { ArchiveUserSecretDTO } from '../model/models';
import { ArchiveUserStatusBodyDTO } from '../model/models';
import { ArchiveUsersResponseDTO } from '../model/models';
import { CreateArchiveUserBodyDTO } from '../model/models';
import { CreatedArchiveUserDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateArchiveUserRequestParams {
    createArchiveUserBodyDTO: CreateArchiveUserBodyDTO;
}

export class ClsCreateArchiveUserRequestParams {
    createArchiveUserBodyDTO: CreateArchiveUserBodyDTO = undefined;
}

export interface DeleteArchiveUserRequestParams {
    archiveUserInternalId: string;
}

export class ClsDeleteArchiveUserRequestParams {
    archiveUserInternalId: string = undefined;
}

export interface GetArchiveUserRequestParams {
    archiveUserInternalId: string;
}

export class ClsGetArchiveUserRequestParams {
    archiveUserInternalId: string = undefined;
}

export interface ListArchiveUsersRequestParams {
    username?: string;
    usernameSearch?: string;
    enabled?: boolean;
    managedObjectType?: string;
    managedObjectId?: string;
    name?: string;
    nameSearch?: string;
    search?: string;
    pageNumber?: number;
    pageSize?: number;
    sort?: string;
}

export class ClsListArchiveUsersRequestParams {
    username?: string = undefined;
    usernameSearch?: string = undefined;
    enabled?: boolean = undefined;
    managedObjectType?: string = undefined;
    managedObjectId?: string = undefined;
    name?: string = undefined;
    nameSearch?: string = undefined;
    search?: string = undefined;
    pageNumber?: number = undefined;
    pageSize?: number = undefined;
    sort?: string = undefined;
}

export interface RegenerateUserSecretRequestParams {
    archiveUserInternalId: string;
}

export class ClsRegenerateUserSecretRequestParams {
    archiveUserInternalId: string = undefined;
}

export interface UpdateArchiveUserRequestParams {
    archiveUserInternalId: string;
    archiveUserBodyDTO: ArchiveUserBodyDTO;
}

export class ClsUpdateArchiveUserRequestParams {
    archiveUserInternalId: string = undefined;
    archiveUserBodyDTO: ArchiveUserBodyDTO = undefined;
}

export interface UpdateStatusRequestParams {
    archiveUserInternalId: string;
    archiveUserStatusBodyDTO: ArchiveUserStatusBodyDTO;
}

export class ClsUpdateStatusRequestParams {
    archiveUserInternalId: string = undefined;
    archiveUserStatusBodyDTO: ArchiveUserStatusBodyDTO = undefined;
}


export interface ArchiveUsersM2mApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create a new technical user for Archive
     * 
* @param requestParameters
     */
    createArchiveUser(requestParameters: CreateArchiveUserRequestParams, extraHttpRequestParams?: any): Observable<CreatedArchiveUserDTO>;

    /**
     * Delete tech user
     * 
* @param requestParameters
     */
    deleteArchiveUser(requestParameters: DeleteArchiveUserRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Get detail of technical users for Archive
     * 
* @param requestParameters
     */
    getArchiveUser(requestParameters: GetArchiveUserRequestParams, extraHttpRequestParams?: any): Observable<ArchiveUserDTO>;

    /**
     * List technical users for Archive
     * 
* @param requestParameters
     */
    listArchiveUsers(requestParameters: ListArchiveUsersRequestParams, extraHttpRequestParams?: any): Observable<ArchiveUsersResponseDTO>;

    /**
     * Request to regenerate and get a new password for a technical user of Archive
     * Request regenerate a new password for an archive M2M user
* @param requestParameters
     */
    regenerateUserSecret(requestParameters: RegenerateUserSecretRequestParams, extraHttpRequestParams?: any): Observable<ArchiveUserSecretDTO>;

    /**
     * Modify detail of technical users for Archive
     * 
* @param requestParameters
     */
    updateArchiveUser(requestParameters: UpdateArchiveUserRequestParams, extraHttpRequestParams?: any): Observable<ArchiveUserDTO>;

    /**
     * Update technical user status
     * 
* @param requestParameters
     */
    updateStatus(requestParameters: UpdateStatusRequestParams, extraHttpRequestParams?: any): Observable<{}>;

}
